function LoadingProgressCircle({ percentage }) {
    const r = 90;
    const c = Math.PI * (r * 2);

    if (percentage < 0) {
        percentage = 0;
    }
    if (percentage > 100) {
        percentage = 100;
    }

    const progress = ((100 - percentage) / 100) * c;
    return (
        <div className="flex items-center justify-center relative">
            <svg width={200} height={200} xmlns="http://www.w3.org/2000/svg" className="transform -rotate-90">
                <circle
                    id="bar"
                    r={90}
                    cx={100}
                    cy={100}
                    fill="transparent"
                    strokeDasharray={565.48}
                    strokeDashoffset={progress}
                    className="transition-all"
                    stroke="#FBA919"
                    strokeWidth={2}
                />
            </svg>
            <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 font-serif text-3xl">
                {percentage.toFixed(1)} %
            </div>
        </div>
    );
}

export default LoadingProgressCircle;
